/*
 * CareIQ specialty preview (owner 10-07: todos shaped by the specialty of the
 * visit's provider; "I want to see how that looks").
 *
 * Off for everyone. One browser turns it on from the DevTools console:
 *     localStorage.setItem("careiq.preview", "specialty")      // off: removeItem
 * Then, and only then:
 *   - the N3 CareIQ calls (ui-flag and the GET) carry ?careiq_preview=specialty;
 *     v2 honours it only for bmadmin / its allowlist (anyone else gets exactly
 *     today's answer) and serves the specialty todo from the preview store;
 *   - a practice without the N3 tab (7825) asks the ui-flag too, and its chart
 *     shows the CareIQ tab once v2 answered "n3" for this login;
 *   - the tab shows one quiet line saying which preview file it is showing;
 *   - the tab is view only: Add (orders/create) and Review (the state POST) are
 *     off while a preview body is shown, so nothing done in a preview reaches
 *     the chart or the reviewed state other users see.
 * Without the key nothing here changes a request or a screen.
 */
export const PREVIEW_KEY = "careiq.preview";
export const PREVIEW_MODE = "specialty";

export function careiqPreviewMode() {
  try {
    return typeof localStorage !== "undefined" && localStorage.getItem(PREVIEW_KEY) === PREVIEW_MODE ? PREVIEW_MODE : null;
  } catch (_) {
    return null;
  }
}

// The request params with the preview flag added (the same object when the preview is off).
export function withPreviewParams(params) {
  const mode = careiqPreviewMode();
  return mode ? { ...(params || {}), careiq_preview: mode } : params;
}

// A body v2 served in preview mode (meta.preview is added only to an allowed preview request).
export function isPreviewBody(body) {
  const p = body && body.meta && body.meta.preview;
  return Boolean(p && typeof p === "object");
}

const VIEW_ONLY = "view only (Add / Review off)";

// The one quiet line for meta.preview (v2 adds it only to an allowed preview request), or null.
export function previewLine(meta) {
  const p = meta && meta.preview;
  if (!p || typeof p !== "object") return null;
  const s = p.specialty && typeof p.specialty === "object" ? p.specialty : null;
  if (p.file === "variant" && s) {
    const bits = [`Specialty preview · ${s.label || s.slug || "specialist"}`];
    if (s.inputs === "claims_only") bits.push("claims and history only (no CareIQ chart summary)");
    else if (s.inputs === "none") bits.push("no CareIQ inputs on file");
    const hidden = Number(s.hidden_pcp_items) || 0;
    if (hidden > 0) bits.push(`${hidden} primary-care item${hidden === 1 ? "" : "s"} hidden`);
    bits.push(VIEW_ONLY);
    return bits.join(" · ");
  }
  if (p.file === "live") return `Specialty preview · no specialty todo for this patient — showing the usual CareIQ · ${VIEW_ONLY}`;
  return `Specialty preview · no specialty todo for this patient · ${VIEW_ONLY}`;
}
